var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wizard-header w-100" }, [
    _c(
      "div",
      { staticClass: "d-flex justify-content-between align-items-center mb-3" },
      [
        _c("h4", { staticClass: "modal-title mb-0" }, [
          _vm._v("Crear Nuevo Documento")
        ]),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button", "aria-label": "Cerrar" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
        )
      ]
    ),
    _c(
      "div",
      { staticClass: "wizard-stepper" },
      _vm._l(_vm.totalSteps, function(step) {
        return _c(
          "div",
          {
            key: step,
            staticClass: "step",
            class: {
              active: step === _vm.currentStep,
              completed: step < _vm.currentStep
            }
          },
          [
            _c("div", { staticClass: "step-number" }, [
              step < _vm.currentStep
                ? _c("span", [_vm._v("✓")])
                : _c("span", [_vm._v(_vm._s(step))])
            ]),
            _c("div", { staticClass: "step-label" }, [
              _vm._v(" " + _vm._s(_vm.getStepLabel(step)) + " ")
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }